import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PathMap } from '@app/@core/enums';
import { AlertService, EmailService } from '@app/@core/services';

import { UsuariosViewModel } from '@app/@auth/shared/usuarios.model';
import {
  EmailViewModel,
  ReceiverEmailViewModel,
  SenderEmailViewModel,
} from '@core/models';
import { CorreoRecuperacion } from '@core/templates';
import { first } from 'rxjs/operators';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  senderEmail: SenderEmailViewModel;

  // loading
  loadingVisible = false;
  constructor(
    private emailService: EmailService,
    private usuarioService: UserService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.senderEmail = new SenderEmailViewModel('', '', '', 0, false);
  }

  ngOnInit(): void {}

  obtenerUsuario(email: string): Promise<UsuariosViewModel> {
    return new Promise<UsuariosViewModel>((resolve, reject) => {
      this.usuarioService
        .getById<UsuariosViewModel>(email, {
          urlPostfix: 'GetUserByEmail',
          mapResponse: (res) => res.modelData,
        })
        .pipe(first())
        .subscribe((usuario) => {
          if (usuario) {
            resolve(usuario);
          } else {
            const item: any = null;
            resolve(item);
          }
        });
    });
  }

  actualizarUsuario(
    usuarioViewModel: UsuariosViewModel
  ): Promise<UsuariosViewModel> {
    return new Promise<UsuariosViewModel>((resolve, reject) => {
      this.usuarioService
        .post<UsuariosViewModel>(usuarioViewModel, {
          urlPostfix: 'UpdateExternal',
          mapResponse: (res) => res.modelData,
        })
        .pipe(first())
        .subscribe((usuario) => {
          if (usuario) {
            resolve(usuario);
          } else {
            const item: any = null;
            resolve(item);
          }
        });
    });
  }

  sendEmail(email: EmailViewModel): Promise<EmailViewModel> {
    return new Promise<EmailViewModel>((resolve, reject) => {
      this.emailService
        .post<EmailViewModel>(email, { urlPostfix: 'Send' })
        .pipe(first())
        .subscribe((send) => {
          if (send) {
            resolve(send);
          } else {
            const item: any = null;
            resolve(item);
          }
        });
    });
  }

  async onSubmit({ correo }) {
    const usuario = await this.obtenerUsuario(correo);

    if (usuario) {
      this.loadingVisible = true;
      const actualizado = await this.actualizarUsuario(usuario);

      const bodyHtml = CorreoRecuperacion.replace(
        '_NombreUsuario_',
        actualizado.nombreUsuario
      )
        .replace('_LoginUsuario_', actualizado.loginUsuario)
        .replace('_claveUsuario_', actualizado.claveUsuario);

      const senderEmail = new SenderEmailViewModel(
        'soporte@ekisa.com.co',
        'mail.ekisa.com.co',
        'E,)]fgDrbL',
        26,
        false
      );
      const item: any = null;
      const renderEmail = new ReceiverEmailViewModel(
        actualizado.correo,
        item,
        'Recuperación de contraseña',
        bodyHtml,
        false,
        []
      );

      const email = new EmailViewModel(senderEmail, renderEmail);
      const enviado = await this.sendEmail(email);
      if (enviado) {
        this.alertService.showSuccess(
          'Se ha enviado un correo electrónico para recuperar la contraseña.',
          4000
        );
        this.router.navigate([PathMap.Auth]);
      }
      this.loadingVisible = false;
    } else {
      this.alertService.showWarning(
        'El correo no se encuentra asociado a ningún usuario.',
        3000
      );
    }
  }
}
